import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from 'app/cluster-styles/useStyles';
import useProviderData from '../hooks/useProviderData';

export default function CredentialSelector({ provider, value, onChange, className }) {
    const classes = useStyles();
    const { credentials } = useProviderData(provider);

    const safeValue = credentials.some((c) => c.id === value) ? value : '';

    return (
        <TextField
            select
            className={clsx(classes.input, className || "flex-1")}
            id="rm-credential"
            name="credential_id"
            label="Credential"
            variant="outlined"
            value={safeValue}
            onChange={(e) => onChange(e.target.value)}
            required
            SelectProps={{
                MenuProps: {
                    PaperProps: {
                        style: { maxHeight: 300 },
                    },
                },
            }}
        >
            {credentials.map((c) => (
                <MenuItem key={c.id} value={c.id}>
                    {c.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
